/**
 * Format a date for display in a table.
 * @param date - A Date object.
 * @returns A string of the date in this format: Aug 5, 2025
 */
export function formatTableDate(date: Date) {
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}
